import { Injectable } from '@angular/core'
import { RegistrationService } from '../services/registration-service'
import { errorToast } from '../toaster'

@Injectable({providedIn: 'root'})
export class RegistrationActions {
  registrationService = new RegistrationService();

  public registerCustomer(body: Object) {
    const p = this.registrationService.registerCustomer(body)

    p.catch(res => {
      const errors = res.body ? res.body.errors : {}
      Object.keys(errors).forEach((key) => {
        const error = `${key} ${errors[key]}`
        errorToast(error)
      })
    })
    return p
  }
}
